/**
 * Capacitor Keyboard 플러그인 초기화
 * - 키보드 이벤트 리스너 등록 (keyboardWillShow / keyboardDidHide)
 * - CSS 커스텀 프로퍼티 --keyboard-height 를 통해 키보드 높이 공유
 * - 네이티브 플랫폼에서만 동작 (PWA에서는 무시)
 */

import { Capacitor } from "@capacitor/core";
import { Keyboard, KeyboardResize } from "@capacitor/keyboard";

/**
 * 네이티브 Keyboard 플러그인 초기화
 * - iOS: resize 모드를 None으로 설정 (WebView 자동 리사이즈 방지)
 * - 키보드 높이를 CSS 변수로 노출하여 컴포넌트에서 활용
 */
export async function initKeyboard(): Promise<void> {
  if (!Capacitor.isNativePlatform()) return;

  try {
    // iOS에서 WebView 자동 리사이즈 비활성화 (직접 제어)
    if (Capacitor.getPlatform() === "ios") {
      await Keyboard.setResizeMode({ mode: KeyboardResize.None });
    }

    // 키보드 높이를 CSS 커스텀 프로퍼티로 노출
    await Keyboard.addListener("keyboardWillShow", (info) => {
      document.documentElement.style.setProperty("--keyboard-height", `${info.keyboardHeight}px`);
      document.documentElement.classList.add("keyboard-open");
    });

    await Keyboard.addListener("keyboardDidHide", () => {
      document.documentElement.style.setProperty("--keyboard-height", "0px");
      document.documentElement.classList.remove("keyboard-open");
    });
  } catch {
    // Keyboard 플러그인이 지원되지 않는 환경에서는 무시
  }
}
